import React, { useEffect } from "react";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/RevenueByLocationSagas";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import { UpdateBtn } from "./smartComponents/UpdateBtn";
import RevenueByLocationCharts from "./smartComponents/RevenueByLocationCharts";

const RevenueByLocationModule = ({ params }) => {
  const dispatch = useDispatch();

  const { chartData, tableData, isLoading, updatesLoading } = useSelector((state) => {
    const { chartData, tableData, isLoading, updatesLoading } = state.revenueByLocation;
    return {
      chartData,
      tableData,
      isLoading,
      updatesLoading
    };
  }, shallowEqual);
  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(params));
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div></div>
            <div className="top-filter__right">
              <div className="select-box-no-width date-range-select-box">
                <p>Date Range</p>
                <CustomDateRanges />
              </div>
              <div className="date-select-box select-box-no-width monthly">
                <p>Date</p>
                <DatePicker />
              </div>
              <UpdateBtn />
            </div>
          </div>
        </div>
        <div data-testid={"charts-container"} className="chart-root">
          {updatesLoading ? (
            <LoadingAnimation text="Updating data..." />
          ) : (
            <>
              <RevenueByLocationCharts
                params={chartData}
                chartName={"earned-revenue-by-location-chart"}
                chartType={"ComboChart"}
                enableEventListeners
                isTableView={false}
              />
              <RevenueByLocationCharts
                params={tableData}
                chartName={"earned-revenue-by-location-table-chart"}
                fixedCols
              />
            </>
          )}
        </div>
      </div>
    );
  };
  return (
    <div id="module-date-filters">
      <SectionToggle
        autoHeight
        paddingBottom={0}
        height={690}
        title="Earned Revenue By Location"
        isLoading={isLoading}
        content={content()}
      />
    </div>
  );
};

export default RevenueByLocationModule;
